import React, { useEffect } from 'react'
import AddProduct from '../../components/AddProducts/AddProduct'
import Layout from '../../components/Layout'
import { useFeatures } from '../../hooks/Features/useFeatures'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import { isArray, ROUTES, uploadFilesToAws } from '../../shared/constants'

export default function Product({ currentProduct }) {
  const [productForm, setProductForm] = React.useState({
    selectCategory: '',
    selectSubCategory: '',
    name: '',
    color: '',
    sku: '',
    distributorPrice: '',
    dealerPrice: '',
    stocks: 0,
    images: [],
    description: '',
    mustItem: [],
    discount: 0,
    tax: null,
    primaryVariant: false,
    secondaryVariant: [],
    primaryImage: [],
    secondaryImage: [],
    active: true,
  })

  const { addProduct, editProduct, loading } = useFeatures()

  useEffect(() => {
    if (currentProduct) {
      setProductForm({
        ...productForm,
        ...currentProduct,
        selectCategory: currentProduct.categoryId && currentProduct.categoryId._id,
        selectSubCategory: currentProduct.subCategoryId && currentProduct.subCategoryId._id,
        tax: currentProduct.tax && currentProduct.tax._id,
        primaryImage: [currentProduct?.primaryImage],
        secondaryImage: [currentProduct?.secondaryImage],
        images: currentProduct?.images,
        active: currentProduct?.active,
        mustItem: currentProduct.mustItem.map((item) => item?._id),
        secondaryVariant: currentProduct.secondaryVariant.map((item) => item?._id),
      })
    }
  }, [currentProduct])

  const handleProduct = async () => {
    let tempPrimaryImage = productForm.primaryImage
    let tempSecondaryImage = productForm.secondaryImage
    let tempImages = productForm.images

    if (!isArray(tempPrimaryImage)) tempPrimaryImage = await uploadFilesToAws(tempPrimaryImage)

    if (!isArray(tempSecondaryImage)) tempSecondaryImage = await uploadFilesToAws(tempSecondaryImage)

    if (!isArray(tempImages)) tempImages = await uploadFilesToAws(tempImages)

    if (currentProduct) {
      editProduct({
        ...productForm,
        productId: currentProduct._id,
        categoryId: productForm.selectCategory,
        subCategoryId: productForm.selectSubCategory,
        primaryImage: tempPrimaryImage[0],
        secondaryImage: tempSecondaryImage[0],
        images: tempImages,
      })
    } else {
      addProduct({
        ...productForm,
        categoryId: productForm.selectCategory,
        subCategoryId: productForm.selectSubCategory,
        primaryImage: tempPrimaryImage[0],
        secondaryImage: tempSecondaryImage[0],
        images: tempImages,
      })
    }
  }

  return (
    <Layout heading={`Product`} heading2={` ${currentProduct ? 'Edit' : 'Add'}`} url1={ROUTES.PRODUCTS} none>
      <HeaderTabLayout
        heading={`${currentProduct ? 'Edit' : 'Add'}  Product `}
        content={<AddProduct state={productForm} setState={setProductForm} />}
        addContent={handleProduct}
        text={`${currentProduct ? 'Update' : 'Add'}`}
        redirect={ROUTES.PRODUCTS}
        loading={loading}
        state={productForm} setState={setProductForm}
      />
    </Layout>
  )
}
